export const FormTypeEnum = {
  ADD_HOME_PLAYER: 'ADD_HOME_PLAYER',
  ADD_PLAYER: 'ADD_PLAYER',
  ALL_FIELDS: 'ALL_FIELDS',
};

export const GenericConfig = () => {
  return [
    {
      FormType: FormTypeEnum.ADD_HOME_PLAYER,
      Title: 'Add / Edit Home Player',
      SubTitle: 'PERSONAL INFO',
      askFor_FirstName: true,
      askFor_LastName: true,
      askFor_Email: false,
      askFor_PhoneNumber: true,
      askFor_Age: false,
      askFor_Gender: false,
      askFor_Notes: false,
      askFor_Login: true,
      askFor_Username: false,
      askFor_Password: true,
    },
    {
      FormType: FormTypeEnum.ALL_FIELDS,
      Title: 'TEST ALL THE FIELDS',
      SubTitle: 'TEST THEM ALL',
      askFor_FirstName: true,
      askFor_LastName: true,
      askFor_Email: true,
      askFor_PhoneNumber: true,
      askFor_Age: true,
      askFor_Gender: true,
      askFor_Notes: true,
      askFor_Login: true,
      askFor_Username: true,
      askFor_Password: true,
    },
  ];
};

export default GenericConfig;
